<cc-top-bar [title]="'NUMBERS.INBOUND_SETTINGS'">
  <a
    (click)="goToNewNumber()"
    title="{{ 'MENU.NEW_NUMBER' | translate }}"
    *ngxPermissionsOnly="'CHANGE_BILLING_PERMISSION'">
    <cc-top-bar-item class="new-number-link">
      <span>+ </span>
      <span translate>MENU.NEW_NUMBER</span>
    </cc-top-bar-item>
  </a>
</cc-top-bar>

<div class="full-width pad-0 lg-down-d-block responsive-menu" [class.open]="!isEmptyPhoneNumbersList()" layout>
  <cc-ng1-phone-number-settings-list [numbers]="phoneNumbers" *ngIf="phoneNumbers"></cc-ng1-phone-number-settings-list>
  <div *ngIf="isEmptyPhoneNumbersList()" class="w-full m-b-0 v-c justify-content-center h-full-vh">
    <div class="text-center">
      <div class="p-b-1 m-b"><img src="/assets/img/old_phone.png"/></div>
      <div class="_700 p-b-1 text-2x" translate="NUMBERS.NO_PHONE"></div>
      <div class="text-md" translate="NUMBERS.CREATE"></div>
      <div class="text-md" translate="NUMBERS.FREE"></div>
    </div>
  </div>
  <div class="responsive-container">
    <cc-section>
      <router-outlet></router-outlet>
    </cc-section>
  </div>
</div>
